import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    changeName: 0
  },
  mutations: {
    CHANGENAME(state, val) {
      state.changeName = val
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js